import styled, { css } from 'styled-components';
import { theme } from 'styled-tools';
import media, { BREAKPOINT_PIXELS } from 'themes/media';
import { ButtonGreen, Button } from 'common/ui/themes/disona/buttons';

const Overlay = styled.section`
  top: 0;
  position: fixed;
  z-index: 2147483602;
  background: rgba(0, 25, 71, 0.7);
  width: 100vw;
  height: 100vh;

  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.7;
    }
  }
`;

const Modal = styled.section`
  z-index: 2147483603;
  position: fixed;
  height: calc(100% - 40px);
  background-color: ${theme('colors.background.blueThird')};
  border-radius: 20px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media (max-width: ${BREAKPOINT_PIXELS.mobileL}) {
    width: calc(100vw - 40px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  @media (min-width: ${BREAKPOINT_PIXELS.mobileL}) {
    width: 680px;
    right: 20px;
    top: 20px;
  }

  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.7;
    }
  }
`;

const ModalIconContainer = styled.div`
  width: 30px;
  height: 30px;
  cursor: pointer;
  border-radius: 50%;
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: white;
    svg path {
      stroke: ${theme('colors.background.primaryColor')};
    }
  }
  position: absolute;
  background: ${theme('colors.background.secondaryColor')};
  svg {
    rotate: 180deg;
  }
`;

const Close = styled(ModalIconContainer)`
  top: 20px;
  right: 20px;
`;

const Back = styled(ModalIconContainer)`
  top: 20px;
  left: 20px;
`;

const Title = styled.section`
  height: 70px;
  display: flex;
  align-items: center;
  font-size: ${theme('sizing.h2')};
  font-weight: 700;
  color: white;
  font-family: 'Untitled Sans', sans-serif;
  margin: 0 20px;

  ${media.lessThan('tablet')`
    font-size: 18px;
  `}
`;

const Body = styled.div`
  width: 100%;
  height: 100%;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  row-gap: 10px;
  flex: 1;
  padding: 40px 20px;
  border-radius: 20px;
  background: ${theme('colors.background.secondaryColor')};
  overflow-y: scroll;
  position: relative;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    margin: 14px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: rgb(119, 118, 118);
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgb(169, 168, 168);
  }

  > * {
    max-width: 420px;
  }
`;

const SubmitContainer = styled.div`
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 10px;
  width: 100%;
`;

const SaveButton = styled(ButtonGreen)`
  width: 150px;
  background: ${theme('colors.background.green')};
  color: black;
  text-transform: uppercase;

  ${media.lessThan('tablet')`
    font-size: ${theme('sizing.text4')};
  `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
      pointer-events: none;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    `}
`;

const CancelButton = styled(Button)`
  width: 150px;
  background: ${theme('colors.background.secondaryColor')};
  color: white;
  text-transform: uppercase;

  ${media.lessThan('tablet')`
    font-size: ${theme('sizing.text4')};
  `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
      pointer-events: none;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    `}
`;

const Gradient = styled.div`
  position: fixed;
  background: linear-gradient(180deg, rgba(0, 55, 101, 0) 0%, #003765 100%);
  height: 70px;
  width: 100%;
  bottom: 90px;
  z-index: 25;
  border-radius: 20px;
  ${media.lessThan('tablet')`
    display: none;
    border-radius: 0;
  `}
`;

export const S = {
  Overlay,
  Modal,
  Close,
  Back,
  Title,
  Body,
  SubmitContainer,
  SaveButton,
  CancelButton,
  Gradient,
};
